<template>
    <section v-if="pageLoader">
        <div class="page-loader">
            {{ $t("loading.loading") }}
        </div>
    </section>
    <section v-else-if="!userIsEmpty('user') && album.owner.id != user.id" class="page-loader">
        {{ $t("albumEdit.youCannotPage") }}
        <redirectButton pathname="home" html="На главную" class="link"></redirectButton>
    </section>
    <section v-else-if="!userIsEmpty('user') && album.owner.id == user.id" class="album-edit">
        <div
            class="section-header section-header-alt album-editable-header album-edit-breadcrumbs-header album-edit-breadcrumbs-header-edit">

            <ul class="container-mobile album-edit-breadcrumbs">
                <li class="album-edit-breadcrumbs-arrow">
                    <router-link :to="{ name: 'profile', params: { id: user.id } }">
                        <!-- {{ albums[0].owner.name }} -->
                        {{ shortenedOwnerName }}
                    </router-link>
                </li>

                <li class="album-edit-breadcrumbs-arrow">
                    <!-- <router-link :to="{ name: 'albums', params: { profileId: user.id } }">
                        {{ $t("albumEdit.my") }}
                        {{ isVideo ? $t("albumEdit.video") : $t("albumEdit.photo") }}
                    </router-link> -->
                    <router-link
                        :to="isVideo ? { name: 'video-albums', params: { profileId: user.id } } : { name: 'albums', params: { profileId: user.id } }">
                        {{ $t("albumEdit.my") }}
                        {{ isVideo ? $t("albumEdit.video") : $t("albumEdit.photo") }}
                    </router-link>
                </li>

                <li class="album-edit-breadcrumbs-overflow">
                    <!-- <div>{{ localAlbum.title }}</div> -->
                    <div>
                        {{ album.album_type === 1 ? $t("albums.general") : album.title }}
                    </div>
                </li>
            </ul>

        </div>
        <div v-if="localAlbum.album_type == 0" class="section-header section-header-alt album-editable-header">
            <div class="container-mobile">
                <div class="album-edit-title">
                    <input id="title" type="text" name="title" v-model="localAlbum.title" @input="updated($event)"
                        @change="updated($event)" v-validate="'required'" :readonly="localAlbum.album_type != 0"
                        class="input" :class="{ 'field-error': errors.has('title') }" />
                    <label for="title" class="v-error label-tip">{{
                        errors.first("title")
                    }}</label>
                </div>
                <span @click="deleteAlbum(albumId)" class="link">{{ $t("albumEdit.deleteAlbum") }}
                    <span v-if="isVideo">
                        {{ $t("albumEdit.video") }}
                    </span></span>
            </div>
        </div>
        <h2 v-else class="heading album-readonly-heading">
            <div class="container-mobile">{{ album.album_type === 1 ? $t("albums.general") : album.title }}</div>
        </h2>

        <div class="info-block container-mobile">
            <div class="album-edit-form">
                <div class="album-edit-form-group avatar-form-group">
                    <label for="avatar" class="label">
                        {{ $t("albumEdit.cover") }}
                    </label>
                    <div class="avatar-preview-wrapper">
                        <input type="file" accept="image/*" id="avatar" name="avatar" @change="updated($event, 'file')"
                            v-validate="'size:10000|ext:jpeg,jpg,png,gif'" data-vv-as="file" class="input-hidden" />
                        <div :style="{
                            'background-image':
                                avatar && !errors.has('avatar') ? 'url(' + avatar + ')' : '',
                        }" class="image-preview" :class="{ 'no-image': !avatar || errors.has('avatar') }">
                            <div v-if="avatar && !errors.has('avatar')" class="delete-image"
                                @click="deleteImage('avatar', 'avatar', null, deleteAvatar)"></div>
                            <label for="avatar" class="change-avatar">
                                {{ $t("albumEdit.change") }}
                            </label>
                        </div>
                    </div>
                </div>
                <div v-if="localAlbum.album_type == 0" class="album-edit-form-group mobile-form-group">
                    <label for="title-mobile" class="label">
                        {{ $t("albumEdit.albumTitle") }}
                    </label>
                    <input id="title-mobile" type="text" name="title" v-model="localAlbum.title" @input="updated($event)"
                        @change="updated($event)" v-validate="'required'" :readonly="localAlbum.album_type != 0"
                        class="input" :class="{ 'field-error': errors.has('title') }" />
                    <label for="title" class="v-error label-tip">
                        {{ errors.first("title") }}
                    </label>
                </div>
                <div class="album-edit-form-group description-form-group">
                    <label for="description" class="label">
                        {{ $t("albumEdit.description") }}
                    </label>
                    <textarea id="description" v-model="localAlbum.description" class="textarea" @input="updated($event)"
                        @change="updated($event)"></textarea>
                </div>
                <span v-if="localAlbum.album_type == 0" @click="deleteAlbum(albumId)" class="link delete-album-mobile">{{
                    $t("albumEdit.deleteAlbum") }}</span>
            </div>

            <div class="buttons-row">
                <redirectButton :pathname="$route.meta.type" :params="{ profileId: user.id, albumId: albumId }"
                    :html="$t('albumEdit.cancel')" class="button-secondary"></redirectButton>
                <button v-if="updateAlbumLoader" class="button button-loader"></button>
                <button v-else @click="updateAlbum" class="button">
                    {{ $t("albumEdit.save") }}
                </button>
            </div>

            <div v-if="!instancesIsEmpty(getMethod())" class="album-edit-photos photos-edit">
                <div class="photos-edit-header">
                    <span class="link" v-if="showLabels && checkedCount > 0" @click="cancelSelection">
                        {{ $t("albumEdit.unselect") }}
                    </span>

                    <span class="link" @click="moveInstances">
                        {{ $t("albumEdit.move") }}
                    </span>
                    <span @click="deleteInstance()" class="link">
                        {{ $t("albumEdit.delete") }}
                    </span>
                </div>
                <div class="photos-edit-list">
                    <div v-for="(instance, index) in instances" :ref="'element' + index" :key="index"
                        class="photos-edit-item">
                        <div :style="{
                            'background-image': instance.image
                                ? 'url(' + instance.image + ')'
                                : '',
                        }" class="photos-edit-inner" :class="{
    'has-image': instance.image,
    'photos-edit-video': isVideo,
}">
                            <div v-if="isVideo && !instance.image" class="photos-process">
                                <span v-if="instance.ready">
                                    {{ $t("albumEdit.videoProcessingError") }}
                                </span>
                                <span v-else>
                                    {{ $t("albumEdit.videoProcessing") }}
                                </span>
                            </div>
                            <input type="checkbox" :checked="checked[index]" @change="updateChecked(index)"
                                :id="'instance' + index" class="input-checkbox" v-if="showLabels" />
                            <label :for="'instance' + index" class="checkbox-label-alt"></label>
                        </div>
                    </div>
                </div>
                <div v-if="moreLoader" class="buttons-center">
                    <button class="button button-loader"></button>
                </div>
            </div>
            <div v-else class="album-edit-photos photos-edit">
                {{ $t("albumEdit.list") }}
                {{ isVideo ? $t("albumEdit.video") : $t("albumEdit.photo") }}
                {{ $t("albumEdit.blank") }}
            </div>
        </div>
    </section>
    <section v-else-if="userIsEmpty('user')" class="no-auth">
        {{ $t("auth.noAuth") }}
        <router-link class="link" tag="a" :to="{ name: 'home' }">
            {{ $t("auth.noAuthLink") }}
        </router-link>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import { localizeValidation } from "@/mixins/localizeValidation";
import { uploadImage } from "@/mixins/uploadImage";
import redirectButton from "@/components/Buttons/Redirect";
import { observeListEnd } from "@/mixins/observeListEnd";

export default {
    name: "Photos",
    props: {
        i18n: Object,
    },
    components: {
        redirectButton,
    },
    mixins: [localizeValidation, uploadImage, observeListEnd],
    data() {
        return {
            albumId: "",
            tempAlbum: {},
            updatedAlbum: {},
            avatar: "",
            image: "",
            imageDescription: "",
            checked: {},
            checkedCount: 0,
            toAlbum: "",
            newAlbumTitle: "",
            selectedAll: false,
            pageLoader: true,
            updateAlbumLoader: false,
            moreLoader: false,
            moreIndex: 0,
            observer: null,
            isVideo: false,
            showLabels: true,
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            userIsEmpty: "user/isEmpty",
            puzzles: "photos/fetchPuzzles",
        }),
        shortenedOwnerName() {
            if (this.albums[0].owner.name.length > 15) {
                return "...";
            }
            return this.albums[0].owner.name;
        },
        albums() {
            return this.$store.getters[
                this.getAlbumMethod() +
                "/fetch" +
                this.getMethod(true, "", false) +
                "Albums"
            ];
        },
        newAlbum() {
            return this.$store.getters[
                this.getAlbumMethod() +
                "/fetchNew" +
                this.getMethod(true, "", false) +
                "Album"
            ];
        },
        albumsErrors() {
            return this.$store.getters[this.getAlbumMethod() + "/errors"];
        },
        instances() {
            return this.$store.getters[
                this.getMethod() + "/fetch" + this.getMethod(true)
            ];
        },
        instancesErrors() {
            return this.$store.getters[this.getMethod() + "/errors"];
        },
        instancesIsEmpty() {
            return this.$store.getters[this.getMethod() + "/isEmpty"];
        },
        count() {
            return this.$store.getters[
                this.getMethod() + "/fetch" + this.getMethod(true) + "Count"
            ];
        },
        next() {
            return this.$store.getters[
                this.getMethod() + "/fetch" + this.getMethod(true) + "Next"
            ];
        },
        album() {
            return this.$store.getters[
                this.getAlbumMethod() +
                "/fetch" +
                this.getMethod(true, "", false) +
                "Details"
            ];
        },
        localAlbum: function () {
            if (Object.keys(this.tempAlbum).length) {
                return this.tempAlbum;
            }
            this.tempAlbum = Object.assign({}, this.album);
            this.avatar = this.tempAlbum.avatar;
            return this.tempAlbum;
        },
    },
    created() {
        this.isVideo = this.$route.meta && this.$route.meta.type == "videos";
        this.albumId = this.$route.params.albumId;
        this.localizeValidation();
        this.getAlbums();
        this.getAlbumDetails();
        this.getInstances();

        let self = this;
        this.observer = new IntersectionObserver(
            function (entries) {
                if (entries[0].isIntersecting === true) {
                    self.showMore();
                }
            },
            { threshold: [0] }
        );
    },
    watch: {
        instances() {
            this.checked = {};
            this.checkedCount = 0;
        },
    },
    beforeDestroy() {
        this.$store.dispatch(this.getMethod(false, "/setIsAlbum"), false);
    },
    methods: {
        getMethod(capitalize = false, method = "", isPlural = true) {
            let str = this.isVideo ? "video" : "photo";
            if (capitalize) str = str.charAt(0).toUpperCase() + str.slice(1);
            if (isPlural) str += "s";
            return str + method;
        },
        getAlbumMethod(method = "") {
            return (this.isVideo ? "videoAlbums" : "albums") + method;
        },
        getAlbums() {
            this.$store.dispatch(this.getAlbumMethod("/getMy"));
        },
        getAlbumDetails() {
            this.$store
                .dispatch(this.getAlbumMethod("/getDetails"), this.albumId)
                .then(() => {
                    this.pageLoader = false;
                })
                .catch(() => {
                    this.pageLoader = false;
                });
        },
        getInstances() {
            this.$store
                .dispatch(this.getMethod(false, "/getAlbum"), this.albumId)
                .then(() => {
                    for (let i = 0; i < this.instances.length; i++) {
                        this.checked[i] = false;
                    }
                    this.updateMoreIndex();
                    this.observeListEnd("element");
                });
        },
        updateAlbum() {
            this.$validator.validateAll().then((valid) => {
                if (valid && Object.keys(this.updatedAlbum).length) {
                    this.updateAlbumLoader = true;
                    const data = {
                        isVideo: this.isVideo,
                        id: this.albumId,
                        data: this.updatedAlbum,
                    };
                    this.$store
                        .dispatch(this.getAlbumMethod("/update"), data)
                        .then(() => {
                            this.updatedAlbum = {};
                            document.getElementById("avatar").value = "";
                            this.errors.clear();
                            this.$validator.reset();
                            this.$modal.show("dialog", {
                                title: this.$t("albumEdit.success"),
                                text: this.$t("albumEdit.albumSuccessfullyUpdated"),
                                buttons: [
                                    {
                                        title: this.$t("albumEdit.ok"),
                                    },
                                ],
                            });
                            this.updateAlbumLoader = false;
                        })
                        .catch(() => {
                            this.updateAlbumLoader = false;
                            if (typeof this.albumsErrors === "object") {
                                for (let key in this.albumsErrors) {
                                    this.errors.add({
                                        field: scope + "." + key,
                                        msg: this.albumsErrors[key][0],
                                    });
                                }
                            }
                        });
                }
            });
        },
        deleteInstance(id = null) {
            let ids;
            if (this.selectedAll) {
                ids = { all: this.albumId };
            } else {
                ids = [];
                if (id) {
                    ids.push(id);
                } else {
                    if (this.checkedCount == 0) {
                        let text = this.isVideo
                            ? this.$t("albumEdit.video")
                            : this.$t("albumEdit.photo");
                        this.$modal.show("dialog", {
                            title: this.$t("albumEdit.warning"),
                            text: this.$t("albumEdit.chooseLeastOne") + text,
                            buttons: [
                                {
                                    title: this.$t("albumEdit.ok"),
                                },
                            ],
                        });
                        return;
                    }
                    for (let key in this.checked) {
                        if (this.checked[key]) {
                            ids.push(this.instances[key].id);
                        }
                    }
                }
            }
            let text = this.isVideo
                ? this.$t("albumEdit.video")
                : this.$t("albumEdit.photo");
            this.$modal.show("dialog", {
                title: this.$t("albumEdit.warning"),
                text: text + this.$t("albumEdit.willBeDeleted"),
                buttons: [
                    {
                        title: "Удалить",
                        handler: () => {
                            this.$store
                                .dispatch(this.getMethod(false, "/delete"), ids)
                                .then(() => {
                                    for (let i in this.checked) {
                                        this.$delete(this.checked, i);
                                    }
                                    this.checkedCount = 0;
                                    this.$modal.hide("dialog");
                                })
                                .catch(() => {
                                    this.$modal.hide("dialog");
                                });
                        },
                    },
                    {
                        title: this.$t("albumEdit.cancel"),
                    },
                ],
            });
        },
        moveInstances() {
            let text = this.isVideo
                ? this.$t("albumEdit.video")
                : this.$t("albumEdit.photo");
            if (this.checkedCount == 0) {
                this.$modal.show("dialog", {
                    title: this.$t("albumEdit.warning"),
                    text: this.$t("albumEdit.chooseLeastOne") + text,
                    buttons: [
                        {
                            title: this.$t("albumEdit.ok"),
                        },
                    ],
                });
                return;
            }
            this.$store.dispatch(this.getMethod(false, "/setIsAlbum"), true);
            let moveArr = [];
            for (let key in this.checked) {
                if (this.checked[key]) {
                    moveArr.push(this.instances[key]);
                }
            }
            this.$modal.show("move-photos", {
                instances: moveArr,
                isVideo: this.isVideo,
            });
        },
        cancelSelection() {
            this.selectedAll = false;
            for (let i in this.checked) {
                this.checked[i] = false;
            }
            this.checkedCount = 0;
            this.showLabels = false;
            setTimeout(() => {
                this.showLabels = true;
            }, 1000);
        },
        deleteAlbum(id) {
            this.$modal.show("dialog", {
                title: this.$t("albumEdit.warningText"),
                text: this.$t("albumEdit.albumWillBeDeleted"),
                buttons: [
                    {
                        title: this.$t("threads.delete"),
                        handler: () => {
                            this.$store
                                .dispatch(this.getAlbumMethod("/delete"), id)
                                .then(() => {
                                    this.$router.push({
                                        name: this.isVideo ? "video-albums" : "albums",
                                        params: { profileId: this.user.id },
                                    });
                                    this.$modal.hide("dialog");
                                })
                                .catch(() => {
                                    this.$modal.hide("dialog");
                                });
                        },
                    },
                    {
                        title: this.$t(albumEdit.cancel),
                    },
                ],
            });
        },
        updated: function (event, type = false) {
            let values;
            if (type == "select") {
                values = [];
                let opts = event.target.options;
                for (let i = 0; i < opts.length; i++) {
                    if (opts[i].selected) {
                        values.push(opts[i].value);
                    }
                }
                this.$set(this.updatedAlbum, event.target.id, values);
            } else if (type == "file") {
                let image = new Image();
                let reader = new FileReader();
                reader.onload = (e) => {
                    if (this.errors.has("avatar")) {
                        this.$modal.show("dialog", {
                            title: this.$t("login.error"),
                            text: this.errors.first("avatar"),
                            buttons: [
                                {
                                    title: "ОК",
                                    handler: () => {
                                        this.errors.clear();
                                        this.$validator.reset();
                                        document.getElementById("avatar").value = "";
                                        this.$modal.hide("dialog");
                                    },
                                },
                            ],
                        });
                    } else {
                        this.avatar = e.target.result;
                        this.$set(this.updatedAlbum, event.target.id, this.avatar);
                    }
                };
                reader.readAsDataURL(event.target.files[0]);
            } else {
                if (this.album[event.target.id] != event.target.value) {
                    this.$set(this.updatedAlbum, event.target.id, event.target.value);
                } else {
                    delete this.updatedAlbum[event.target.id];
                }
            }
        },
        deleteAvatar() {
            this.$set(this.tempAlbum, "avatar", "");
            this.$set(this.updatedAlbum, "avatar", "");
        },
        updateChecked(index) {
            this.checked[index] = !this.checked[index];
            let count = 0;
            for (let key in this.checked) {
                if (this.checked[key]) {
                    count++;
                }
            }
            this.checkedCount = count;
            if (this.checkedCount < this.instances.length) {
                this.selectedAll = false;
            }
            // console.log('this.checkedCount', this.checkedCount);
        },
        checkAll() {
            for (let key in this.checked) {
                this.checked[key] = true;
            }
            this.checkedCount = Object.keys(this.checked).length;
            this.selectedAll = true;
        },
        uncheckAll() {
            for (let key in this.checked) {
                this.checked[key] = false;
            }
            this.checkedCount = 0;
            this.selectedAll = false;
        },
        updateMoreIndex() {
            for (let i = 0; i < this.count; i++) {
                if (!this.instances[i]) {
                    this.moreIndex = i - 2;
                    return;
                }
            }
        },
        showMore() {
            let firstEmpty;
            for (let i = 0; i < this.count; i++) {
                if (!this.instances[i]) {
                    firstEmpty = i;
                    break;
                }
            }
            if (this.next && firstEmpty) {
                this.moreLoader = true;
                this.$store
                    .dispatch(this.getMethod(false, "/getNext"))
                    .then(() => {
                        this.observeListEnd("element", false, true, true);
                        this.moreLoader = false;
                    })
                    .catch(() => {
                        this.moreLoader = false;
                    });
            } else {
                this.observeListEnd("element", false, true);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_validation";
@import "~@/assets/styles/components/_votes";
@import "~@/assets/styles/pages/_album-edit";
</style>
